import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5086dfb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = {
  key: 0,
  class: "w-full md:flex md:flex-col"
}
const _hoisted_3 = { class: "flex items-end flex-nowrap mb-25 mt-20" }
const _hoisted_4 = { class: "mr-30 whitespace-nowrap text-dusty-grey" }
const _hoisted_5 = { class: "mr-30 whitespace-nowrap" }
const _hoisted_6 = { class: "mr-30 whitespace-nowrap" }
const _hoisted_7 = { class: "md:border-b w-full py-15 md:flex md:justify-between md:items-center" }
const _hoisted_8 = {
  key: 0,
  class: "border-b pb-10 mb-20 lowercase md:py-8 md:mb-0 md:border-0"
}
const _hoisted_9 = { class: "w-full md:ml-auto md:w-auto md:flex md:flex-col md:justify-between md:h-full" }
const _hoisted_10 = {
  key: 0,
  class: "text-center flex flex-col"
}
const _hoisted_11 = { class: "px-20" }
const _hoisted_12 = { class: "pr-4" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "pl-4" }
const _hoisted_15 = {
  key: "hasNoWishListItems",
  class: "mt-40"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WishListRename = _resolveComponent("WishListRename")!
  const _component_WishListDeleteButton = _resolveComponent("WishListDeleteButton")!
  const _component_WishListShareButton = _resolveComponent("WishListShareButton")!
  const _component_NativeShareButton = _resolveComponent("NativeShareButton")!
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!
  const _component_AddToBasket = _resolveComponent("AddToBasket")!
  const _component_WishListItem = _resolveComponent("WishListItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.details.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_WishListRename, {
              show: _ctx.titleIsBeingRenamed,
              "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.titleIsBeingRenamed) = $event)),
              title: _ctx.details.name
            }, null, 8, ["show", "title"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createElementVNode("button", {
                  class: "c-magic-line",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.toggleWishlistRenameMode()), ["prevent"]))
                }, _toDisplayString(_ctx.labels.renameBtn), 1)
              ]),
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_WishListDeleteButton)
              ]),
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_NativeShareButton, {
                  "share-button-text": _ctx.labels.shareListBtn,
                  "share-url": _ctx.shareUrl,
                  "link-title": _ctx.details.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_WishListShareButton, {
                      "share-url": _ctx.shareUrl,
                      "share-image": _ctx.listDefaultImageUrl
                    }, null, 8, ["share-url", "share-image"])
                  ]),
                  _: 1
                }, 8, ["share-button-text", "share-url", "link-title"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.details.numberOfProducts)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.details.numberOfProducts) + " " + _toDisplayString(_ctx.labels.items), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.isBrandSite)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_RouterLinkConditional, {
                class: "c-button c-button--basket mb-10",
                to: _ctx.findStoresLink.url,
                "spa-enabled": _ctx.findStoresLink.spaLink,
                title: _ctx.labels.createProfileLinkText
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$dictionary.get('b2c/brandsite/findstore')), 1)
                ]),
                _: 1
              }, 8, ["to", "spa-enabled", "title"]),
              _createElementVNode("p", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$dictionary.get('b2c/brandsite/or')), 1),
                _createElementVNode("a", {
                  href: _ctx.pageStore.changeCountryUrl,
                  class: "c-magic-line c-magic-line--underline"
                }, _toDisplayString(_ctx.$dictionary.get('b2c/footer/selectyourcountry')), 9, _hoisted_13),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$dictionary.get('b2c/brandsite/toshoponline')), 1)
              ])
            ]))
          : (_openBlock(), _createBlock(_Transition, {
              key: 1,
              name: "o-anim-fade-300"
            }, {
              default: _withCtx(() => [
                (!_ctx.loadingDetails && _ctx.areAllWishListItemReadyForPurchase)
                  ? (_openBlock(), _createBlock(_component_AddToBasket, {
                      key: 0,
                      items: _ctx.wishListItemsForAddToBasket,
                      "button-text": _ctx.labels.addListToBasket,
                      class: "w-full md:min-w-350",
                      onAddToBasket: _ctx.trackAddListToBasket
                    }, null, 8, ["items", "button-text", "onAddToBasket"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
      ])
    ]),
    _createVNode(_TransitionGroup, {
      "leave-active-class": "transition-height-wishlist ease-in-out animated fadeOut u-anim-dur-200",
      "leave-from-class": "max-height",
      "leave-to-class": "max-h-0"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details.wishListItems, (item) => {
          return (_openBlock(), _createBlock(_component_WishListItem, {
            key: item.id,
            "allow-add-to-basket": _ctx.isPurchaseAble(item.variant.sku),
            item: item,
            readonly: false
          }, null, 8, ["allow-add-to-basket", "item"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_Transition, { "enter-active-class": "animated fadeIn u-anim-dur-300 u-anim-delay-300" }, {
      default: _withCtx(() => [
        (!_ctx.hasWishListItems)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_15, _toDisplayString(_ctx.labels.emptyList), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}